import { Component, HostBinding } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { DarkmodeService } from './_provider/darkmode.service';
import { MenuService } from './_provider/menu.service';
import { Router } from '@angular/router';
import { AuthService } from './_provider/auth.service';
import { GeneralService } from './_provider/general.service';
import { StatusBar, Style } from '@capacitor/status-bar'
import { Location } from '@angular/common';
import { QuickSearchService } from './_provider/quick-search.service';
import { Subscription } from 'rxjs';
import { FeedbackService, MsgType } from './_provider/feedback.service';
import { BreadcumbService } from './_provider/breadcumb.service';
import { register } from 'swiper/element/bundle';
import { SentryService } from './_provider/sentry/sentry.service';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { HttpService } from './_provider/http.service';
import { ResizeManagerService } from './_provider/resize-manager.service';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  public isDarkmode: boolean = false;
  public menuOpen: boolean;
  public menuReady: boolean = true;
  public isLogin: boolean
  // public isCustomer: boolean = false
  public messagesOpen: boolean

  @HostBinding("style.--navigation-width.px")
  public navigationWidth: number = 50;

  constructor(
    private darkmode: DarkmodeService,
    private platform: Platform,
    public menu: MenuService,
    private router: Router,
    public authSrv: AuthService,
    private location: Location,
    private sentrySrv: SentryService,
    private feedback: FeedbackService,
    private genaral: GeneralService,
    private http: HttpService,
    public modalCtrl: ModalController,
    public quickSearchSrv: QuickSearchService,
    public breadcrumpSrv: BreadcumbService
  ) {

    this.initializeApp();
    this.darkmode.isDarkMode.subscribe(result=>{
      this.isDarkmode = result;
    })

    this.menu.isMenuOpen.subscribe(result=>{
      this.menuOpen = result;
      if (!result){
        setTimeout(() => {
          this.menuReady = true
        }, 300);
      }else{
        this.menuReady = false
      }
    })

    const menuSub: Subscription = this.router.events.subscribe(()=>{
      if (location.path() === "" 
      || location.path().startsWith("/login") 
      || location.path().startsWith("/password-recovery") 
      || location.path().startsWith("/ticket/ShowTicket/")
      || location.path().startsWith("/partylicenses")
      // || location.path().startsWith("/ticket-tab/")
      ){
        this.isLogin = true
        
      }
      else if(location.path().startsWith("/tabs/home")) this.isLogin = false
      else if(location.path().startsWith("/customer")) this.isLogin = false
    })

    this.genaral.messageOpen.subscribe(result=>{
      this.messagesOpen = result
    })
    this.genaral.setMessageOpenStatus(false)
  }


  initializeApp() { 
    this.http.setBaseURL()
    this.platform.ready().then(async () => {
      await this.darkmode.setStartupMode()
      if(this.platform.is("capacitor")){
        // await StatusBar.setOverlaysWebView({ overlay: false });
      }
      this.setScreenorientation()
      this.sentrySrv.loadSentryEnabled()

      
    });
  }
  
  private async setScreenorientation(){
    if(this.platform.is("tablet"))
      await ScreenOrientation.unlock()
  } 

}
 